import { Link } from "react-router-dom";

export const Logo = ({ className = "" }) => {
  return (
    <Link
      to="/"
      data-testid="site-logo"
      className={`flex items-center gap-2 group ${className}`}
    >
      {/* Air Fryer icon */}
      <span
        aria-hidden="true"
        className="inline-flex h-9 w-9 items-center justify-center rounded-full"
        style={{ backgroundColor: "var(--jaf-primary)" }}
      >
        <svg
          viewBox="0 0 24 24"
          width="20"
          height="20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-white"
        >
          <rect x="5" y="3" width="14" height="18" rx="3" />
          <circle cx="12" cy="13" r="3.5" />
          <path d="M9 6h6" />
          <path d="M17 7v1.5" />
        </svg>
      </span>
      <span
        className="font-serif text-2xl tracking-tight"
        style={{ color: "var(--jaf-text)" }}
      >
        Just<span style={{ color: "var(--jaf-primary)" }}>AirFry</span>
      </span>
    </Link>
  );
};

export default Logo;
